import { CloudUpload as UploadFileIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import React, { useRef } from 'react';

export default function FileUploader({ accept, addFile, ButtonProps = {}, disabled, label }) {
    const hiddenFileInput = useRef(null);

    const handleClick = () => {
        hiddenFileInput.current.click();
    };
    const handleChange = event => {
        const fileUploaded = event.target.files[0];
        addFile(fileUploaded);
    };
    return (
        <>
            <Button
                color="primary"
                disabled={disabled}
                onClick={handleClick}
                startIcon={<UploadFileIcon />}
                {...ButtonProps}
            >
                {label}
            </Button>
            <input
                accept={accept}
                hidden
                onChange={handleChange}
                ref={hiddenFileInput}
                type="file"
            />
        </>
    );
}
